export const WEEK_STARTS_ON_MONDAY_STORAGE_KEY = "sky-view:preferences:weekStartsOnMonday";

export const readWeekStartsOnMondayPreference = (fallback: boolean = true): boolean => {
  if (typeof window === "undefined") {
    return fallback;
  }
  try {
    const stored = window.localStorage.getItem(WEEK_STARTS_ON_MONDAY_STORAGE_KEY);
    if (stored === "true") {
      return true;
    }
    if (stored === "false") {
      return false;
    }
    return fallback;
  } catch (_error) {
    return fallback;
  }
};

export const persistWeekStartsOnMondayPreference = (value: boolean) => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(WEEK_STARTS_ON_MONDAY_STORAGE_KEY, value ? "true" : "false");
  } catch (_error) {
    // Ignore storage failures (private mode, quota, etc.)
  }
};
